"use client";

import { c as _c } from "react/compiler-runtime";
import ChewySwapText from "@/components/Image/Svg/ChewySwapText";
import FeatureCard from "@/components/Page/Home/FeatureCard";
import { Icon } from "@iconify/react";
import { delay, wrap } from "motion";
import { Button, Link, ScrollShadow, type ScrollShadowProps } from "@heroui/react";
import { AmbulanceIcon, Coins, DropletIcon, Droplets, Images, Layers, Newspaper, Image, Wallet } from "lucide-react";
import AppScreenshotSkewed from "./AppScreenshotSkewed";
import { Typewriter } from "motion-plus/react";
import { useState } from "react";
const text = ["Welcome to ChewySwap", "All-in-one DogFi Platform", "Swap, Stake, Bridge and more!"];
const isVertical = true;
const duration = "10";
export default function HomeHero() {
  const $ = _c(28);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      isEnabled: true,
      size: 25,
      orientation: isVertical ? "vertical" : "horizontal",
      visibility: "both"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const shadowProps = t0;
  const [index, setIndex] = useState(0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Button as={Link} href="https://t.me/chewyswapcommunity" rel="noopener" target="_blank" className="h-9 overflow-hidden border-1 border-default-100 bg-default-50 px-[18px] py-2 text-small font-normal leading-5 text-default-500" startContent={<Icon className="flex-none outline-none [&>path]:stroke-[2]" icon="uim:telegram-alt" width={20} />} radius="full" variant="bordered">Join our Community!</Button>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== index) {
    t2 = () => {
      delay(() => setIndex(wrap(0, text.length, index + 1)), 1);
    };
    $[2] = index;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = text[index];
  let t4;
  if ($[4] !== t2 || $[5] !== t3) {
    t4 = <div className="text-start text-[clamp(20px,5vw,22px)] font-bold leading-[1.2] tracking-tighter sm:text-[64px] bg-gradient-to-r dark:from-[#FFFFFF] dark:to-[#FFFFFF66] bg-clip-text text-transparent"><Typewriter as="div" onComplete={t2}>{t3}</Typewriter></div>;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="inline-block text-start font-normal leading-7 text-default-500 sm:w-[466px] sm:text-[18px]"><ChewySwapText width="120px" height="20px" className="inline-block mr-2" />Farms + Launchpad is your one-stop shop for everything from earning yield on your tokens to kickstarting your own project on Shibarium and Dogechain. We bring staking pools from the top projects in the space to one place, so you can have your treats and eat them too!</div>;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Button as={Link} href="./farms" rel="prefetch" className="h-10 w-[163px] bg-default-foreground px-[16px] py-[10px] text-small font-medium leading-5 text-background" radius="full">Fetch Rewards!</Button>;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:gap-6">{t6}<Button as={Link} href="#features" className="h-10 w-[163px] border-1 border-default-100 px-[16px] py-[10px] text-small font-medium leading-5" endContent={<span className="pointer-events-none flex h-[22px] w-[22px] items-center justify-center rounded-full bg-default-100"><Icon className="text-default-500 [&>path]:stroke-[1.5]" icon="solar:arrow-right-linear" width={16} /></span>} radius="full" variant="bordered">Features</Button></div>;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t4) {
    t8 = <section className="container mx-auto mt-[10px] flex max-w-[1024px] flex-col items-start px-8"><div className="z-20 flex flex-col items-start justify-center gap-[18px] sm:gap-6">{t1}<div className="flex flex-col gap-6">{t4}{t5}{t7}</div></div></section>;
    $[10] = t4;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="absolute top-[40%] w-full"><AppScreenshotSkewed className="w-full -mt-20 md:mt-0" /></div>;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t8) {
    t10 = <div className="relative flex h-screen min-h-[500px] max-h-[800px] w-full flex-col overflow-hidden">{t8}{t9}</div>;
    $[13] = t8;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      "--gap": "4",
      "--duration": `${duration}s`
    };
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <h2 className="text-3xl font-bold mb-12 text-center">Chewy Features</h2>;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <FeatureCard title="NFT Marketplace" description="Trade, list, and discover NFTs from the top collections on Shibarium" icon={<Image className="w-8 h-8" />} link="/marketplace" />;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <FeatureCard title="Rescue Mission" description="Rescue your stuck funds from dead & abandoned staking protocols and pools" icon={<AmbulanceIcon className="w-8 h-8" />} link="/rescue" />;
    $[18] = t14;
  } else {
    t14 = $[18];
  }
  let t15;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <FeatureCard title="Portfolio Tracker" description="View your token and NFT portfolio across multiple chains" icon={<Wallet className="w-8 h-8" />} link="https://docs.chewyswap.com/products/portfolio-tracker" />;
    $[19] = t15;
  } else {
    t15 = $[19];
  }
  let t16;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <FeatureCard title="Staking" description="Earn rewards by staking your tokens and liquidity across multiple farms & pools." icon={<Coins className="w-8 h-8" />} link="/farms" />;
    $[20] = t16;
  } else {
    t16 = $[20];
  }
  let t17;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <FeatureCard title="DEX Aggregator" description="Find the best rates across multiple DEXes and pairs with our aggregator" icon={<Layers className="w-8 h-8" />} link="/swap" />;
    $[21] = t17;
  } else {
    t17 = $[21];
  }
  let t18;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <FeatureCard title="Liquidity Management" description="Manage your liquidity across multiple exchanges and chains in one place" icon={<Droplets className="w-8 h-8" />} link="/liquidity" />;
    $[22] = t18;
  } else {
    t18 = $[22];
  }
  let t19;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <FeatureCard title="NFT Staking" description="Stake your NFTs to earn rewards and participate in exclusive events" icon={<Images className="w-8 h-8" />} link="/nft-staking" />;
    $[23] = t19;
  } else {
    t19 = $[23];
  }
  let t20;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <FeatureCard title="Latest News" description="Stay up to date in the world of DogFi and crypto in general in our news section" icon={<Newspaper className="w-8 h-8" />} link="/news" />;
    $[24] = t20;
  } else {
    t20 = $[24];
  }
  let t21;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <ScrollShadow {...shadowProps} style={t11}><section id="features" className="py-16 bg-slate-600/25"><div className="container mx-auto px-4">{t12}<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 justify-items-center" id="features">{t13}{t14}{t15}{t16}{t17}{t18}{t19}{t20}<FeatureCard title="Cross-Chain Bridge" description="Easily transfer assets across multiple chains with our integrated bridge" icon={<Icon icon="ph:bridge-bold" className="w-8 h-8" />} link="/bridge" /></div></div></section></ScrollShadow>;
    $[25] = t21;
  } else {
    t21 = $[25];
  }
  let t22;
  if ($[26] !== t10) {
    t22 = <>{t10}{t21}</>;
    $[26] = t10;
    $[27] = t22;
  } else {
    t22 = $[27];
  }
  return t22;
}